/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-css-modules/~/lodash/_setToArray.js
 ** module id = 2514
 ** module chunks = 0
 **/